import React, {useState, useEffect} from 'react';
import Axios from 'axios';
import Carrusel from './carrusel';
import { NotLogin } from './ver';
import Dale from '../home/dale'
import AllList from './list';
import ImgEncuesta from '../../static/img_encuesta.svg';
import ScrollAnimation from 'react-animate-on-scroll';


import Footer from '../footer';

import { UserProvider, useUser, usuario } from '../../context/UserContext'

let CarruselContainer = ( { data } ) => {
  return (
    <section className="slider-causas">
      <div className="container">
        
        <ScrollAnimation animateIn='bounceInLeft' animateOnce={true} >
        <h3>{data.titulo}</h3>
        <span className="subtitle">{data.subtitulo}</span>
        </ScrollAnimation>
                
        <ScrollAnimation animateIn='bounceInRight' animateOnce={true} >
          <Carrusel />    
        </ScrollAnimation>
      </div>
    </section>
  )
} 


export default function Causas() {
  
  const [items, setItems] = useState([]);
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();
  useEffect(()=>{
    function fetchItems() {
      Axios.get(process.env.REACT_APP_API + '/api/v1/causas')
           .then( response => {
             setItems(response.data.slice(0, 3));
           })
           .catch( e => {
             console.log(e);
           })
    }
    fetchItems()
  },[])
  
  return (
    <section className="causas-last">
      
      { usuario !== null ? <CarruselContainer data={{ titulo : usuario.first_name +', estas causas pueden interesarte.', subtitulo: 'Analizamos tus gustes, intereses y ubicación y estas causas podrían interesarte.'}} /> : null }
      { usuario !== null ? (
        <div className="encuesta-dispatch">
          <div className="encuesta-dispatch-container">
            <div className="encuesta-dispatch-left">
              <div className="encuesta-dispatch-left-content">
                <h2>Un Pulso para  <br/>
                el cambio social</h2>
                <div className="desc">
                Las personas son la esencia de nuestro Pulso. Detras de cada causa hay Pulsos, detras de ese Pulso podes estár vos.
                </div>
                <a href="https://pulso.social/" className="button" target="_blank">Unete a pulso</a>
              </div>
            </div>
            <div className="encuesta-dispatch-right">
              <img src={ImgEncuesta} alt=""/>
            </div>
          </div>
        </div>
      ) : null }
        
      
        <div className="container">
          { usuario !== null ? 
            (
              <div>
                <h3>Otras causas que necesitan tu apoyo</h3>
                <span className="subtitle">Estas son otras causas apoyadas por personas con tus mismos intereses.</span>
              </div>
            ) : (
              <div>
                <h3>Causas que necesitan tu apoyo</h3>
                <span className="subtitle">Las personas son la esencia de nuestro Pulso. Detras de cada causa hay Pulsos, detras de ese Pulso podes estár vos.</span>
              </div>
            )
          }
          <div className="columns">
            <div className="column">
            <AllList />
            </div>
            <div className="column">
            { usuario !== null ? (
              <div>
                <h4>Causas apoyadas por otros hombres</h4>
                <AllList limit="3"/>
                
                <h4>Causas apoyadas por personas de tu generacion</h4>
                <AllList limit="3"/>
              </div>
            ) : <NotLogin data={{title : 'Hay causas que necesitan tu Pulso.', description : 'Hay causas importantes para vos, registrate con tu perfil de Facebook para encontrar causas más relativas a vos!'}}/> }
            </div>
          </div>
        </div>
      
    </section>
    
  )
}